import { plural, t } from "@lingui/core/macro"
import { isLinguiMigrateActive } from "../../common/featureFlagUtil"
import { i18n } from "../../common/translation"

/**
 * Generates the localized preview text for a tip message in conversation lists.
 *
 * @param tipAmount The amount of the tip.
 * @param fromUsername The username of the user who sent the tip.
 * @param otherUsername The username of the other user in the conversation (the one displayed).
 * @param currentUsername The username of the currently logged-in user.
 * @returns The localized string for the tip preview.
 */
export const getTipPreviewText = ({
    tipAmount,
    fromUsername,
    otherUsername,
    currentUsername,
}: {
    tipAmount: number,
    fromUsername: string,
    otherUsername: string,
    currentUsername: string | undefined,
}): string => {
    if (tipAmount <= 0 || currentUsername === undefined) {
        return ""
    }

    const isCurrentUserSender = fromUsername === currentUsername
    const relevantUsername = isCurrentUserSender ? otherUsername : fromUsername

    const tokenText = plural(tipAmount, {
        one: `${tipAmount} token`,
        other: `${tipAmount} tokens`,
    })

    const tipText = isLinguiMigrateActive()
        ? isCurrentUserSender
            ? t`You tipped ${tokenText}.`
            : t`${relevantUsername} tipped you ${tokenText}.`
        : isCurrentUserSender
            ? i18n.sentTipDmNotice(tipAmount)
            : i18n.receivedTipDmNotice(relevantUsername, tipAmount)

    return tipText
}
